import { useContext } from 'react';

import FeatureFlagsContext from './feature-flags-context';
import type { FeatureFlagsContextProps } from './types';

const useFeatureFlags = (): FeatureFlagsContextProps => {
  const context = useContext(FeatureFlagsContext);

  if (!context) {
    throw new Error(
      'useFeatureFlags must be used within a FeatureFlagsProvider'
    );
  }

  return context;
};

export default useFeatureFlags;
